<app-header class="no-print"></app-header>

<div class="no-print center-align">
  <div style="font-weight: bold; display: flex; align-items: center;">
    <app-date-range-picker [dateRangeForm]="dateRangeForm"
      (dateChange)="handleDateChange(dateRangeForm.value.start, dateRangeForm.value.end)"
      (dateClear)="clearDates()" >
    </app-date-range-picker>
    <div>
      <mat-radio-group [(ngModel)]="mode" aria-label="Select an option">
        <mat-radio-button value="notes" (change)="handleModeChange($event)" style="color:black;">Release Notes</mat-radio-button>
        <mat-radio-button value="summary" (change)="handleModeChange($event)" style="color:black;">Executive Summary</mat-radio-button>
      </mat-radio-group>
    </div>
    <button mat-raised-button class="button" onclick="window.print()">Print</button>
  </div>
</div>
@if (dateRangeForm.value.start && dateRangeForm.value.end && mode === 'notes') {
  <div class="center-align">
    <img style="margin-bottom: 20px;" class="image" src="../../assets/adesa_color.png" alt="logo">
    <div class="title">
      <h2 style="font-size: 30px">ADESA PRODUCT DEVELOPMENT</h2>
    </div>
    <div class="subtitle">
      <h2 style="font-size: 25px; font-weight: normal; padding-bottom: 20px;">Summary of Changes</h2>
    </div>
    <div class="releasedate">
      <h2 style="font-size: 25px">{{ reportTitle }}</h2>
    </div>
  </div>
  <div #summary class="summary">
    <div class="page-break"></div>
    <div style="padding-left: 0;">
      <h2 style="font-size: 30px">Summary of changes in this release</h2>
    </div>
    <div style="padding-left: 0;">
      <h2 class="header-text">ADESA</h2>
    </div>
    <ng-container>
      <ul style="margin: 0;">
        @for (application of releaseNotes.Applications; track application) {
          @if (application.Name) {
            <li class="list-item">
              <a (click)="scrollToSection(application.Name, 'app')">{{ application.Name }}</a>
            </li>
          }
        }
      </ul>
    </ng-container>
    <div style="padding-left: 0;">
      <h2 class="header-text">Customers</h2>
    </div>
    <ng-container>
      <ul style="margin: 0;">
        @for (customer of releaseNotes.Customers; track customer) {
          <li class="list-item">
            <a (click)="scrollToSection(customer.Name ?? 'N/A', 'customer')">{{ customer.Name ?? 'N/A' }}</a>
          </li>
        }
      </ul>
    </ng-container>
    <div style="padding-left: 0;">
      <h2 class="header-text">ADESA, by application</h2>
    </div>
    @for (application of releaseNotes.Applications; track application) {
      @if (application.Name) {
        <div style="padding-left: 0;">
          <a id="app-{{ application.Name }}"></a>
          <h2 style="font-size: 25px; background-color: #e6e6e6">{{ application.Name }}</h2>
        </div>
      }
      @for (feature of application.Features; track feature) {
        <span style="font-size: 13pt; padding: 5px;">
          <a rel="noopener" target="_blank" href="{{feature.Link}}">#{{ feature.FeatureID }} ({{ feature.State }}) - {{
            feature.Title
          }}</a>
        </span>
        @for (workItem of feature.WorkItems; track workItem) {
          <span style="font-size: 10pt; padding: 3px;">
            <a rel="noopener" target="_blank" href="{{workItem.Link}}">#{{ workItem.WorkItemID }} - {{ workItem.Title
            }}</a>
          </span>
          @if (workItem.ReleaseNotes) {
            <span style="font-size: 12pt; padding: 5px;"
            [innerHTML]="sanitizeHtml(updateImageStyles(workItem.ReleaseNotes))"></span>
          }
        }
      }
    }
    <div style="padding-left: 0;">
      <h2 class="header-text">Customer Driven Changes</h2>
    </div>
    @for (customer of releaseNotes.Customers; track customer) {
      <div style="padding-left: 0;">
        <a id="customer-{{ customer.Name ?? 'N/A' }}"></a>
        <h2 style="font-size: 25px; background-color: #e6e6e6">{{ customer.Name ?? 'N/A' }}</h2>
      </div>
      @for (feature of customer.Features; track feature) {
        <span style="font-size: 13pt; padding: 5px;">
          <a rel="noopener" target="_blank" href="{{feature.Link}}"> #{{ feature.FeatureID }} ({{ feature.State }}) - {{
            feature.Title
          }}</a>
        </span>
        @for (workItem of feature.WorkItems; track workItem) {
          <span style="font-size: 10pt; padding: 3px;">
            <a rel="noopener" target="_blank" href="{{workItem.Link}}">#{{ workItem.WorkItemID }} @if (workItem.UATCompletedBy) {
              (UAT: {{ workItem.UATCompletedBy }})
              } - {{ workItem.Title
            }}</a>
          </span>
          @if (workItem.ReleaseNotes) {
            <span style="padding: 5px;"
            [innerHTML]="sanitizeHtml(updateImageStyles(workItem.ReleaseNotes))"></span>
          }
        }
      }
    }
  </div>
}
@if (dateRangeForm.value.start && dateRangeForm.value.end && mode === 'summary') {
  <div class="center-align">
    <img style="margin-bottom: 20px;" class="image" src="../../assets/adesa_color.png" alt="logo">
    <div class="title">
      <h2 style="font-size: 30px">ADESA PRODUCT DEVELOPMENT</h2>
    </div>
    <div class="subtitle">
      <h2 style="font-size: 25px; font-weight: normal; padding-bottom: 20px;">Press Release</h2>
    </div>
    <div class="releasedate">
      <h2 style="font-size: 25px">{{ reportTitle }}</h2>
    </div>
  </div>
  <div class="summary">
    <div class="page-break"></div>
    <div class="summarySectionHeader">
      <h2 style="font-size: 30px">Executive Summary</h2>
    </div>
    <div class="summarySubsectionHeader">
      <h2 style="font-size: 14px; line-height: 0;">Purpose</h2>
    </div>
    <span>
      This document has been compiled to callout selected deliverables within a Release that provide value to our
      customers or our organization.
      This is not intended to be a comprehensive collection of all value delivered; rather, it contains highlights that
      Product Management considers might be of general interest.
    </span>
    <div class="page-break"></div>
    <div class="summarySectionHeader">
      <h2 style="font-size: 30px">Deliverables in detail</h2>
    </div>
    @for (customer of execSummary.Customers; track customer) {
      <div class="summarySubsectionHeader">
        <h2 style="font-size: 14px; line-height: 0;">{{ customer.Name ?? 'N/A' }}</h2>
      </div>
      <table aria-describedby="summary" class="summaryTable">
        <tbody>
          @for (feature of customer.Features; track feature) {
            <tr>
              <th scope="col"></th>
              <th scope="col"></th>
              <td class="summaryRow">{{ feature.Title}}</td>
              <td class="summaryRow" [innerHTML]="feature.BusinessValueStatement"></td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
}
